import React from 'react';
import { addMonths, parseISO, toDate } from 'date-fns';
import { safeAddDays } from './utils';
export const useSliderHandlers = ({ currentMonthISO, isMonthExist, onMonthChange, onPricesEnd, setOpenedDate }) => {
    const onItemCentered = React.useCallback((startItemIndex, minDate) => {
        const day = safeAddDays(minDate, startItemIndex);
        setOpenedDate(day);
    }, [setOpenedDate]);
    const sliderArrowHandler = React.useCallback((direction, _startItemIndex, _itemsCount, itemsOutsideBoundary) => {
        if (itemsOutsideBoundary !== 0) {
            return;
        }
        const nextMonth = addMonths(parseISO(currentMonthISO), direction === 'next' ? 1 : -1);
        if (!isMonthExist(nextMonth)) {
            onPricesEnd === null || onPricesEnd === void 0 ? void 0 : onPricesEnd(addMonths(nextMonth, -11), direction);
        }
        onMonthChange && onMonthChange(nextMonth);
        setOpenedDate(toDate(nextMonth));
    }, [currentMonthISO, isMonthExist, onMonthChange, onPricesEnd, setOpenedDate]);
    const mobileArrowHandler = React.useCallback((startItemIndex, minDate) => {
        const date = safeAddDays(minDate, startItemIndex);
        setOpenedDate(toDate(date));
    }, [setOpenedDate]);
    return { onItemCentered, sliderArrowHandler, mobileArrowHandler };
};
